import { useTranslation } from 'react-i18next';
import type { RideScope } from '../hooks/useRides.ts';

const SCOPES: readonly RideScope[] = ['rides', 'all'];

/** "Rides | All" filter chips above the rides list and calendar. */
export function RideScopeChips({
  scope,
  onChange,
}: Readonly<{ scope: RideScope; onChange: (scope: RideScope) => void }>) {
  const { t } = useTranslation();
  return (
    <fieldset className="flex gap-2 mb-4 border-0 p-0 m-0">
      <legend className="sr-only">{t('activities.chips.label')}</legend>
      {SCOPES.map((s) => (
        <button
          key={s}
          type="button"
          aria-pressed={scope === s}
          onClick={() => onChange(s)}
          className={`px-3 py-1 rounded-full text-xs font-medium border transition-colors ${
            scope === s
              ? 'bg-(--color-accent)/15 text-(--color-accent) border-(--color-accent)/40'
              : 'bg-(--color-bg-tertiary) text-(--color-text-secondary) border-(--color-border) hover:border-gray-400'
          }`}
        >
          {t(`activities.chips.${s}`)}
        </button>
      ))}
    </fieldset>
  );
}
